import React from 'react';
import { EVO_ICONS, type EvoIconName } from './evo-icons';

/* EvoHub Icon System v1 (rediseño V2).
 * Caja única 24×24 para TODOS los iconos; el trazo se recalcula
 * (weight × 24 / size) para que un icono a 18px y otro a 56px rendericen
 * exactamente la misma línea de 1.5px. Ya no existen variantes -large:
 * el mismo glifo sirve para sidebar y hero. */

/* Aliases del sistema viejo → glifo nuevo. Mantienen typecheck y render de
 * páginas aún no migradas; se eliminan cuando ningún caller los use. */
const LEGACY_ALIASES = {
  facturacion: 'billing',
  envelope: 'email',
  person: 'contacts',
  return: 'reply',
  ok: 'check',
  paperclip: 'attach',
} as const satisfies Record<string, EvoIconName>;

type LegacyIconName = keyof typeof LEGACY_ALIASES;

export type IconName = EvoIconName | LegacyIconName;

interface IconProps {
  name: IconName;
  size?: number;
  /** Grosor de línea RENDERIZADO en px, constante a cualquier tamaño. */
  strokeWidth?: number;
  className?: string;
  'aria-label'?: string;
}

const BOX = 24;

export function Icon({
  name,
  size = 18,
  strokeWidth = 1.5,
  className,
  'aria-label': ariaLabel,
}: IconProps) {
  const resolved: EvoIconName =
    name in EVO_ICONS ? (name as EvoIconName) : LEGACY_ALIASES[name as LegacyIconName];
  const sw = +((strokeWidth * BOX) / size).toFixed(3);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={!ariaLabel}
      aria-label={ariaLabel}
      dangerouslySetInnerHTML={{ __html: EVO_ICONS[resolved] }}
    />
  );
}
